<template>  
  <div>
  <v-row v-if="type == 'panelists'" class="mb-5">
    <PanelistList></PanelistList>
  </v-row>
  <v-row v-else class="mb-5">
    <v-col>
      <p class="text-large" v-if="blurbs[type]">{{blurbs[type]}}</p>
      <v-card class="mx-auto mb-5">      
        <v-toolbar color="black" dark class="mw-h2">
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
        <v-data-table
          :search="search"
          :headers="headers[type]"
           v-model="selected"
          :items="rows"
          :options="options"
          :show-select="showSelect"
          :selected="selected"
          class="elevation-1"
          >
          <template v-slot:item.active="{item}">
            <span class="text-center">
              <v-icon v-if="item.active" color="green">mdi-check-circle</v-icon>
            </span>
          </template>
          <template v-slot:item.client="{item}">
            <span v-if="item.client">
              <span v-if="organisations.find(a => a.id == item.client)">{{organisations.find(a => a.id == item.client).name}}</span>
            </span>
          </template>
          <template v-slot:item.surveyResponseCount="{item}"> 
            <span v-if="item.active">
              <SurveyResponseCounter :survey="item"></SurveyResponseCounter>
            </span>
          </template>
          <template v-slot:item.surveyResponseLastUpdated="{item}"> 
            <span v-if="item.active">
              <SurveyResponseLastUpdated :survey="item"></SurveyResponseLastUpdated>
            </span>
          </template>
          <template v-slot:item.surveyProjects="{item}"> 
            <span v-if="item.active">
              <a v-for="project in projects.filter(a => a.screener == item.id)" :key="project.id" :href="'/edit/projects/' + project.id ">{{project.internalName}}</a>
            </span>
          </template>
          <template v-slot:item.organisation="{item}">
            <span v-if="item.organisation">
              <span v-if="organisations.find(a => a.id == item.organisation)">{{organisations.find(a => a.id == item.organisation).name}}</span>
            </span>
          </template>
          <template v-slot:item.tagString="{item}">
            <Tags :inline="true" :saveOnChange=false :panelist="item"></Tags>
          </template>
          <template v-slot:item.status="{item}">
           <span v-if="item.status">{{ prettyPrint( item.status, "TITLE" ) }}</span>
          </template>
          <template v-slot:item.created="{item}">
            <span v-if="item.created">
              {{ item.created.toDate() | moment("D/MM/YYYY HH:mm") }}
            </span>
          </template>
          <template v-slot:item.createdBadge="{item}">
            <span v-if="item.created">
              <v-badge class="ml-2" :color="colourSince(item.created.toDate())" :content="timeSince(item.created.toDate()) +' days'"></v-badge>
            </span>
          </template>
          <template v-slot:item.startDate="{item}">
            <span v-if="item.startDate">
              {{ item.created.toDate() | moment("D/MM/YYYY") }}
            </span>
          </template>
          <template v-slot:item.endDate="{item}">
            <span v-if="item.endDate">
              {{ item.created.toDate() | moment("D/MM/YYYY") }}
            </span>
          </template>
          <template v-slot:item.buttons="{item}">
            <div>
                <Delete :collection="type" :item="item"></Delete>
                <v-btn small class="green ml-2 float-right" dark link :to="{ name:'edit', params: {type: type, id: item.id }}">Edit</v-btn>
            </div>
          </template>    
          <template v-slot:item.displayName="{item}">
            <v-hover v-slot:default="{ hover }">
              <div>
                {{ item.displayName }}
                <v-btn v-if="hover" icon absolute style="margin-top: -6px" @click="preview(item)"><v-icon>mdi-magnify</v-icon></v-btn>
              </div>
            </v-hover>



          </template>     

          <template v-slot:body.append>
            <tr>
              <td v-for="header in headers[type]" :key="header.value">
                <div v-if="header.columnFilter">
                  <v-switch color="green" v-if="header.columnFilter.type == 'switch'" :value="true" v-model="otherFilters[header.value]"></v-switch>
                  <v-combobox v-if="header.columnFilter.type == 'select'" v-model="otherFilters[header.value]" :items="filterOptions[header.value]" multiple chips></v-combobox>
                </div>
              </td>
            </tr>
          </template>                
          </v-data-table>
          <v-btn absolute dark fab bottom left color="accent"  v-if="!displayNewForm" @click="displayNewForm = true">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          <v-btn absolute dark fab bottom left color="warning"  v-if="displayNewForm"  @click="displayNewForm = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
      </v-card>
      <v-card v-if="displayNewForm" class="mx-auto mb-5">
        <component v-on:complete="hideNewForm" v-bind:is="type + 'Form'" v-bind="newProps[type]"></component>
      </v-card>
    </v-col>
  </v-row>
  <v-row>
    <v-col >
      <v-btn class="mb-3" v-if="displayImport"  color="red" @click="displayImport = 0" dark>Cancel</v-btn>
      <v-btn class="mb-3" v-if="includeImport && !displayImport"  color="primary" @click="displayImport = 1">Import</v-btn>
            <Import v-if="includeImport && displayImport" v-bind="importProps" v-on:complete="completeImport"></Import>

    </v-col>
  </v-row>


  </div>
</template>


<script>
  import Vue from "vue";
  import Vuex from 'vuex';
  
  import {prettyPrint, sortByKey } from "../assets/utilities.js";
  import Delete from "../components/tools/Delete";
  import ViewUser from "../components/singles/ViewUser.vue"

  export default {
    name: "AdminList",
    props: {'type': {type: String}, "items": {type: Array }},
    components: {
      organisationsForm: () => import('../components/forms/NewOrganisationForm'),
      postsForm: () => import('../components/forms/NewPostForm'),
      projectsForm: () => import('../components/forms/NewProjectForm'),
      clientsForm: () => import('../components/forms/NewUserForm'),
      adminsForm: () => import('../components/forms/NewUserForm'),
      // messagesForm: () => import('../components/forms/NewMessageForm'),
      surveysForm: () => import('../components/forms/NewSurveyForm'),
      panelistsForm: () => import('../components/forms/NewUserForm'),
      Import: () => import("../components/tools/Import"),
      Tags: () => import("../components/tools/Tags"),
      SendCustomMessage: () => import( "../components/tools/SendCustomMessage" ),
      SurveyResponseCounter: () => import( "../components/tools/SurveyResponseCounter.vue" ),
      SurveyResponseLastUpdated: () => import( "../components/tools/SurveyResponseLastUpdated.vue" ),
      Delete: Delete,
      ViewUser: ViewUser,
      PanelistList: () => import("../components/subpanels/PanelistList.vue")
    },
    data() {
      return {
        tagDialog: false,
        queryDialog: false,
        addMultiDialog: false, 
        messagesDialog: false,
        previewDialog: false,
        search: '',
        previewItem: null,
        selected: [],
        displayImport: false,
        filteredIds: [],
        otherFilters: {},
        displayNewForm: false,
        addMultiTags: [],
        newProps: {
          clients:{
            role: "client"
          },
          admins:{
            role: "admin"
          },
          panelists:  {
            role: "panelmember"
          }
        },
        blurbs:{
          projects: "The table below includes all projects associated with your account. You can sort and filter the table as needed, and edit project information using the ‘Edit’ button.", 
          panelists: "The table below provides access to your database of potential participants. You can query, search and sort the available information, perform single or bulk edits, send single or bulk messages, and import further records below"
        },  
        headers: {
          panelists: [
            {  value: "displayName", text: 'Name' },
            {  value: 'status', text: 'Status' },
            {  value: 'email', text: 'Email' },
            {  value: 'phone', text: 'Phone' },
            {  value: 'tagString', text: 'Tags' },
            {  value: 'created', text: 'Created', date: true },
            {  value: 'buttons', text: ' ' }
          ],
          requests: [
            {  value: 'created', text: 'Created', date: true },
            {  value: 'createdBadge', text: ''},
            {  value: "status", text: 'Status' },
            {  value: "title", text: 'Title' },
            {  value: "organisation", text: 'Organisation' },
            {  value: 'startDate', text: 'Start', date: true },
            {  value: 'endDate', text: 'End', date: true },
            {  value: 'buttons', text: ' ' }
          ],
          clients: [
            {  value: "displayName", text: 'Name' },
            {  value: "organisation", text: 'Organisation' },
            {  value: "email", text: 'Email' },
            {  value: "phone", text: 'Phone' },
            {  value: "jobTitle", text: 'Job Title' },
            {  value: "location", text: 'Location' },
            {  value: 'created', text: 'Created', date: true },
            {  value: 'buttons', text: ' ' }
          ],
          posts: [
            {  value: "title", text: 'Title' },
            {  value: 'created', text: 'Created', date: true },
            {  value: 'buttons', text: ' ' }
          ],
          admins: [
            {  value: "displayName", text: 'Name' },
            {  value: 'created', text: 'Created', date: true },
            {  value: 'buttons', text: ' ' }
          ],
          surveys: [
            {  value: "active", text: 'Live', columnFilter: {type: "switch"} },
            {  value: "name", text: 'Name' },
            {  value: "surveyResponseCount", text: 'Responses' },
            {  value: "surveyResponseLastUpdated", text: 'Last Response' },
            {  value: "surveyProjects", text: 'Projects' },
            {  value: 'created', text: 'Created', date: true },
            {  value: 'buttons', text: ' ' }
          ],
          locations: [
            {  value: "name", text: 'Name' },
            {  value: 'created', text: 'Created', date: true },
            {  value: 'buttons', text: ' ' }
          ],
          instructions: [
            {  value: "name", text: 'Name' },
            {  value: 'created', text: 'Created', date: true },
            {  value: 'buttons', text: ' ' }
          ],
          organisations: [
            {  value: "name", text: 'Name' },
            {  value: 'created', text: 'Created', date: true },
            {  value: 'buttons', text: ' ' }
          ],
          // messages: [
          //   {  value: "name", text: 'Name' },
          //   {  value: 'created', text: 'Created', date: true },
          //   {  value: 'buttons', text: ' ' }
          // ],
          projects: [
            {  value: "active", text: 'Live', columnFilter: {type: "switch"} },
            {  value: "client", text: 'Client Organisation'   },
            {  value: "clientName", text: 'Client Project Name' },
            {  value: "internalName", text: 'Internal Project Name' },
            {  value: 'buttons', text: ' ' }
          ],
        },
        options: {
          page: 1,
          itemsPerPage: this.type == "surveys" ? -1 : 10,        
        },

      };
    },
    computed: {
      ...Vuex.mapState({
          user: state => state.auth.user,
          view: state => state.auth.view,
          projects: state => state.admin.projects,
          organisations: function(state){
            if( !state[state.auth.view] ){ return }
            return state[state.auth.view].organisations;
          },
          tags: function(state){
            if( !state[state.auth.view] ){ return [] }
            else{
              return state[state.auth.view].tags
            }
          } 
        }),
        rows(){
          const self = this;
          let items = self.items;
          if( self.filteredIds.length > 0 ){
            items = self.items.filter( i => self.filteredIds.indexOf(i.id) > -1 );
          }
          for( var key in self.otherFilters ){
            if( self.otherFilters[key] == null ){
              items = self.items.filter( i => !i[key] );
            }
            else{

              if( self.otherFilters[key] ){
                if( typeof self.otherFilters[key] == "object" ){
                  items = self.items.filter( i => self.otherFilters[key].indexOf(i[key]) > -1 );
                }
                else{
                  items = self.items.filter( i => self.otherFilters[key] == i[key] );
                }
              }
            }
          }
          items.forEach( i => {
            if( i.updated ){
              i.sortBy = i.updated.seconds;
            }
          })

          items = sortByKey( items, "sortBy")
          items.reverse();
          return items;
          
        },
        showSelect(){
          var i = false;
          if(this.type == "panelists"){
            i = true; 
          }
          return i;
        },
        recipients: function(){
          let recipients = [];
          this.selected.forEach( a => {
              recipients.push( a.id )
          })
          return recipients
        },
        includeImport(){
          var i = false;
          if( ["panelists", "admins", "clients" ].indexOf(this.type) > -1 ){
            i = true; 
          }
          return i;
        },
        importCollection(){
          var ref = this.type;
          if( ["panelists", "admins", "clients" ].indexOf(this.type) > -1 ){
            ref = "users"; 
          }
          return ref;
        },
        importProps(){
          let props =  {}
          if(this.type == "panelists"){
            props = {
              initialFields: ['firstName', 'lastName', 'email', 'phone'],
              defaults: {role: "panelcandidate", publishStatus: "live"},
              fieldFunctions: {
                displayName: function(object){
                  return object.firstName + " " + object.lastName;
                } 
              }
            }
          }
          if(this.type == "clients"){
            props = {
              initialFields: ['firstName', 'lastName', 'email', 'phone'],
              defaults: {role: "client", publishStatus: "live"},
              fieldFunctions: {
                displayName: function(object){
                  return object.firstName + " " + object.lastName;
                } 
              }
            }
          }
          if(this.type == "admins"){
            props = {
              initialFields: ['firstName', 'lastName', 'email', 'phone'],
              defaults: {role: "admin", publishStatus: "live"},
              fieldFunctions: {
                displayName: function(object){
                  return object.firstName + " " + object.lastName;
                } 
              }
            }
          }
          return props;
        }
    },
    created: function(){
      const self = this;
      if( self.type == 'panelists' ){
        self.$store.dispatch("bindTags" )
      }
      if( self.type == 'projects' || self.type == 'clients' ){
        self.$store.dispatch("fetch", "organisations" )
      }
      if( self.type == 'surveys' ){
        self.$store.dispatch("fetch", "projects" )
      }
    },
    watch: {
      type(){
        this.displayNewForm = false;
        this.search = "";
      },
      items(){
        const self = this;
        if( !self.tags ){ return; }
        self.items.forEach( item => {
          if( item.tags ){
            item.tagString = item.tags.map( tagId=>{ 
              let tag = self.tags.find( tag => tag.id == tagId);
              if( tag ){ 
                return tag.displayName 
              } 
            }).join(", ")
          }
          else{
            item.tagString = "";
          }
            
        })
      }    
    }, 
    methods: {
      sortByKey: sortByKey,
      prettyPrint: prettyPrint,
      preview(item){
        this.previewItem = item;
        this.previewDialog = true;
      },
      timeSince(date){
        var given = Vue.moment(date);
        var current = Vue.moment().startOf('day');
        return 0-Math.floor(Vue.moment.duration(given.diff(current)).asDays() );
      },
      colourSince(date){
        let days = this.timeSince(date);
        if( days > 7 ){
          return "red"
        }
        if( days > 2 ){
          return "warning"
        }

        return "green";
      },
      hideNewForm: function(){
        this.displayNewForm = false;
      },
      completeImport(array){
        const self = this;
        let collection = self.importCollection;
        array.forEach( a => {
          self.$store.dispatch( "addDoc", {
            collection: collection, 
            data: a
          })
        })
        this.displayImport = 0;
      },
      saveMultiTags: function(){
        var self = this;
        this.selected.forEach( panelmember => {
          let update = false;
          let currentTags = [];
          if( panelmember.tags){
            currentTags = panelmember.tags;
          }
          self.addMultiTags.forEach( tag => {
            if(currentTags.indexOf( tag.id ) < 0  ){
              currentTags.push( tag.id );
              update = true;
            }
            if( update ){          
              self.$store.dispatch("updateDoc", {
                doc: "users/"+ panelmember.id,
                action: "update",
                data: {tags: currentTags}
              }).then(() => self.dialog2 = false)
            }
          })
        })
        self.tagDialog = false;
      },
      completeQuery( results ){
        if( results ){
          this.filteredIds = results;
        }
        this.dialog4 = false;
      }
    }
  };
</script>